"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRefetch = require("react-refetch");

var _crowdaaApi = _interopRequireDefault(require("crowdaa-api"));

var _get = _interopRequireDefault(require("lodash/get"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AuthorizeChecker = function AuthorizeChecker() {
  return null;
};

AuthorizeChecker.contextTypes = {
  apiURL: _propTypes.default.string,
  loginToken: _propTypes.default.string,
  userId: _propTypes.default.string
};

var _default = _reactRefetch.connect.defaults(new _crowdaaApi.default({
  type: 'no-store'
}))(function (props, context) {
  var apiURL = context.apiURL;
  var url = new URL("".concat(apiURL, "/authorize"));
  return {
    authFetch: {
      context: context,
      url: url,
      refreshInterval: 60000,
      andCatch: function andCatch(reason, meta) {
        var code = (0, _get.default)(meta, 'response.status', 0);

        if (code === 403 || code === 401) {
          var onError = props.onError;
          if (onError) onError(reason);
        }

        return {}; // react refetch wait for object
      }
    }
  };
})(AuthorizeChecker);

exports.default = _default;